import React from 'react'

import { Loader } from '@cvg/react-components'

import EntryCard from '@components/Entry/EntryCard'

import styles from './styles.module.css'

const Entries = ({ entries, isLoadingMore }) => {
  if (!entries.length) return <p>No media found for these filters.</p>

  return (
    <div className={styles.entries}>
      <ul>
        {entries.map(entry => (
          <EntryCard key={entry.id} entry={entry} />
        ))}
      </ul>

      {isLoadingMore && <Loader text='Loading...' />}
    </div>
  )
}

export default Entries
